import {
  Auth,
  DeAuth,
  ApplicationStatusRequest,
  QueryContract,
  QueryLegalEntities,
  QueryAvailableContractTerms,
  QueryDocument,
  QueryContractDocument,
  QueryLegalDocumentList,
  AckNotifications as AcknowledgeNotifications,
  UIContractWorkflowAction as WorkflowAction,

} from '../@types'

export enum REQUEST_MESSAGE_TYPES {
  ApplicationStatusRequest = 'ApplicationStatusRequest',
  Auth = 'Auth',
  DeAuth = 'DeAuth',
  QueryContract = 'QueryContract',
  QueryNotifications = 'QueryNotifications',
  QueryCreateActions = 'QueryCreateActions',
  QueryContractHistory = 'QueryContractHistory',
  QueryLegalEntities = 'QueryLegalEntities',
  QueryAvailableContractTerms = 'QueryAvailableContractTerms',
  QueryPurposeTypes = 'QueryPurposeTypes',
  AcknowledgeNotifications = 'AcknowledgeNotifications',
  QueryDocument = 'QueryDocument',
  QueryContractDocument = 'QueryContractDocument',
  QueryLegalDocumentList = 'QueryLegalDocumentList',
  WorkflowAction = 'WorkflowAction',
  UITriContractCREATE = 'UITriContractCREATE',
  AddPrivateParty = 'AddPrivateParty',
  AdminQueryUsers = 'AdminQueryUsers',
  AdminQueryCreateActions = 'AdminQueryCreateActions',
  AdminQueryRoles = 'AdminQueryRoles',
  AdminQueryLegalEntities = 'AdminQueryLegalEntities',
  AdminQueryOrgUnits = 'AdminQueryOrgUnits',
  UIAdminWorkflowAction = 'UIAdminWorkflowAction'
}
export type Request = {
  messageType: REQUEST_MESSAGE_TYPES
  messageId: string
  Auth?: Auth
  ApplicationStatusRequest?: ApplicationStatusRequest
  DeAuth?: DeAuth
  QueryContract?: QueryContract
  QueryCreateActions?: {}
  QueryContractHistory?: {}
  QueryNotifications?: {}
  QueryLegalEntities?: QueryLegalEntities
  QueryAvailableContractTerms?: QueryAvailableContractTerms
  AcknowledgeNotifications?: AcknowledgeNotifications
  QueryPurposeTypes?: {}
  QueryDocument?: QueryDocument
  QueryContractDocument?: QueryContractDocument
  QueryLegalDocumentList?: QueryLegalDocumentList
  WorkflowAction?: WorkflowAction
}
